<div [class]="'app-sidebar sidebar-shadow ' + (config$ | async).sidebarTheme" (mouseover)="sidebarHover()"
  (mouseout)="sidebarHover()">

  <div class="app-header__logo">
    <div routerLink="/home" class="logo-src cp"></div>
    <div class="header__pane ml-auto">
      <button type="button" class="hamburger close-sidebar-btn hamburger--elastic"
        [ngClass]="{'is-active' : globals.toggleSidebar}" (click)="toggleSidebar()">
        <span class="hamburger-box">
          <span class="hamburger-inner"></span>
        </span>
      </button>
    </div>
  </div>


  <div class="app-sidebar-content" style="overflow-y:auto;">
    <div class="app-sidebar-scroll">

      <perfect-scrollbar>



        <div class="v-sidebar-menu vsm-default">


          <div class="vsm-list">
            <ngb-accordion [destroyOnHide]="false" [closeOthers]="true" [activeIds]="extraParameter">



              <!--  <ngb-panel>
                <ng-template ngbPanelHeader>
                  <div class="vsm-header">MENU</div>
                </ng-template>
              </ngb-panel> -->

              <ngb-panel id="homeMenu">
                <ng-template ngbPanelHeader>
                  <button routerLinkActive="active-item" routerLink="/home" ngbPanelToggle class="vsm-link mt-2">
                    <i class="vsm-icon pe-7s-rocket"></i>
                    <span class="vsm-title">Home</span>
                  </button>
                </ng-template>
              </ngb-panel>



              <section *ngIf="(this.tipoInstalacao == 'SS' || this.tipoInstalacao == 'SSPT') && 
              (this.podeAcessar.SolicitarSpv || this.podeAcessar.AcompanharSpv || 
              this.podeAcessar.AvaliarSpv || this.podeAcessar.ProgramarServico)">
                <ngb-panel>
                  <ng-template ngbPanelHeader>
                    <div class="vsm-header" title="Módulo Solicitação de Serviços">Módulo SS</div>
                  </ng-template>
                </ngb-panel>
                <ngb-panel id="solicitante" *ngIf="(this.podeAcessar.SolicitarSpv || this.podeAcessar.AcompanharSpv)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-note"></i>
                      <span class="vsm-title">Solicitante</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.SolicitarSpv">
                          <a routerLinkActive="active-item" routerLink="/solicitar-spv" class="vsm-link">
                            <span class="vsm-title">Solicitar SS</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.AcompanharSpv">
                          <a routerLinkActive="active-item" routerLink="/acompanhar-spv" class="vsm-link">
                            <span class="vsm-title" title="Acompanhar Solicitação de Serviços">Acompanhar SS</span></a>
                        </div>

                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="gestorSpv" *ngIf="this.podeAcessar.AvaliarSpv">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-user"></i>
                      <span class="vsm-title" title="Gestor Solicitação de Serviços">Gestor SS</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.AvaliarSpv">
                          <a routerLinkActive="active-item" routerLink="/avaliar-spv" class="vsm-link">
                            <span class="vsm-title" title="Avaliar Solicitação de Serviços">Avaliar SS</span></a>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>




              </section>


              <!-- MÓDULO PT -->




              <section *ngIf="(this.tipoInstalacao == 'PT' || this.tipoInstalacao == 'SSPT') && 
              (this.podeAcessar.SolicitarPt || this.podeAcessar.AcompanharPt)">
                <ngb-panel>
                  <ng-template ngbPanelHeader>
                    <div class="vsm-header">Módulo PT</div>
                  </ng-template>
                </ngb-panel>
                <ngb-panel id="solicitantept" *ngIf="(this.podeAcessar.SolicitarPt || this.podeAcessar.AcompanharPt)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-note"></i>
                      <span class="vsm-title">Solicitante</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent *ngIf="(this.podeAcessar.SolicitarPt || this.podeAcessar.AcompanharPt)">
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.SolicitarPt">
                          <a routerLinkActive="active-item" routerLink="/solicitar-pt" class="vsm-link">
                            <span class="vsm-title">Solicitar PT</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.AcompanharPt">
                          <a routerLinkActive="active-item" routerLink="/acompanhar-pt" class="vsm-link">
                            <span class="vsm-title">Acompanhar PT</span></a>
                        </div>

                      </div>
                    </div>
                  </ng-template>

                </ngb-panel>


              </section>













              <!-- MÓDULO PT -->
















              <section *ngIf="(this.podeAcessar.Fabricante || this.podeAcessar.Material || 
              this.podeAcessar.Categoria || this.podeAcessar.Funcionario || this.podeAcessar.Estoque || 
              this.podeAcessar.EmitirOS || this.podeAcessar.EmitirOsAutomatica || this.podeAcessar.FecharOs
              || this.podeAcessar.TratarOSAvaliada || this.podeAcessar.VistoDeExecucao || this.podeAcessar.ValidarOS
              )">


                <ngb-panel>
                  <ng-template ngbPanelHeader>
                    <div class="vsm-header">Módulo Operacional</div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="cadastrosBasicos" *ngIf="(this.podeAcessar.Fabricante  || 
              this.podeAcessar.Categoria || this.podeAcessar.Funcionario || this.podeAcessar.Estoque)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon lnr-layers"></i>
                      <span class="vsm-title">Cadastros Básicos</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.Fabricante">
                          <a routerLinkActive="active-item" routerLink="/fabricante" class="vsm-link">
                            <span class="vsm-title">Fabricante</span></a>
                        </div>

                        <div class="vsm-item" *ngIf="this.podeAcessar.Categoria">
                          <a routerLinkActive="active-item" routerLink="/categoria" class="vsm-link">
                            <span class="vsm-title">Categoria Funcional</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.Funcionario">
                          <a routerLinkActive="active-item" routerLink="/funcionario" class="vsm-link">
                            <span class="vsm-title">Funcionário</span></a>
                        </div>

                        <!-- <div class="vsm-item" *ngIf="this.podeAcessar.Estoque">
                        <a routerLinkActive="active-item" routerLink="/estoque" class="vsm-link">
                          <span class="vsm-title">Cadastramento de Estoque</span></a>
                      </div>  -->

                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>



                <ngb-panel id="ordemservico" *ngIf="(this.podeAcessar.EmitirOS || this.podeAcessar.EmitirOsAutomatica || 
              this.podeAcessar.FecharOs || this.podeAcessar.TratarOSAvaliada || this.podeAcessar.VistoDeExecucao || this.podeAcessar.ValidarOS)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-news-paper"></i>
                      <span class="vsm-title">Ordem de Serviço</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.ProgramarServico">
                          <a routerLinkActive="active-item" routerLink="/programar-servico" class="vsm-link">
                            <span class="vsm-title">Programar Serviço</span></a>
                        </div>

                        <div class="vsm-item" *ngIf="this.podeAcessar.EmitirOS">
                          <a routerLinkActive="active-item" routerLink="/emitir-os" class="vsm-link">
                            <span class="vsm-title">Emitir OS</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.EmitirOsAutomatica">
                          <a routerLinkActive="active-item" routerLink="/emitir-os-automatica" class="vsm-link">
                            <span class="vsm-title">Emitir OS Preventiva</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.TratarOSAvaliada">
                          <a routerLinkActive="active-item" routerLink="/tratar-os-avaliada" class="vsm-link">
                            <span class="vsm-title">Tratar OS avaliada</span></a>
                        </div>
                         <div class="vsm-item" *ngIf="this.podeAcessar.VistoDeExecucao">
                          <a routerLinkActive="active-item" routerLink="/visto-de-execucao" class="vsm-link">
                            <span class="vsm-title">Visto de Execucao</span></a>
                        </div>
                        
                        <div class="vsm-item" *ngIf="this.podeAcessar.FecharOs">
                          <a routerLinkActive="active-item" routerLink="/fechar-os" class="vsm-link">
                            <span class="vsm-title">Fechar OS</span></a>
                        </div>
                         <div class="vsm-item" *ngIf="this.podeAcessar.ValidarOS">
                          <a routerLinkActive="active-item" routerLink="/validar-os" class="vsm-link">
                            <span class="vsm-title">Validar OS</span></a>
                        </div>


                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>


                <ngb-panel id="relatorios-rd" *ngIf="(this.podeAcessar.EquipamentoRD || this.podeAcessar.ModeloRD || 
              this.podeAcessar.EmitirRD)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-date"></i>
                      <span class="vsm-title">Relatório Diário RD</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.ProgramarServico">
                          <a routerLinkActive="active-item" routerLink="/equipamento-rd" class="vsm-link">
                            <span class="vsm-title">Equipamentos para o RD</span></a>
                        </div>

                        <div class="vsm-item" *ngIf="this.podeAcessar.EmitirOS">
                          <a routerLinkActive="active-item" routerLink="/modelo-rd" class="vsm-link">
                            <span class="vsm-title">Modelos de RD</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.EmitirOsAutomatica">
                          <a routerLinkActive="active-item" routerLink="/emitir-rd" class="vsm-link">
                            <span class="vsm-title">Cadastrar/Emitir RD</span></a>
                        </div>


                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>


                <ngb-panel id="estoque-materiais" *ngIf="(this.podeAcessar.TipoMaterial 
              || this.podeAcessar.Material ||  this.podeAcessar.EntradaMaterial)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-config"></i>
                      <span class="vsm-title">Estoque de materiais</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">

                        <div class="vsm-item" *ngIf="this.podeAcessar.TipoMaterial">
                          <a routerLinkActive="active-item" routerLink="/tipo-material" class="vsm-link">
                            <span class="vsm-title">Tipo Material</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.Material">
                          <a routerLinkActive="active-item" routerLink="/material" class="vsm-link">
                            <span class="vsm-title">Material</span></a>
                        </div>

                        <div class="vsm-item" *ngIf="this.podeAcessar.EntradaMaterial">
                          <a routerLinkActive="active-item" routerLink="/entrada-material" class="vsm-link">
                            <span class="vsm-title">Entrada Material</span></a>
                        </div>

                        <div class="vsm-item" *ngIf="this.podeAcessar.EntradaPeriodo">
                          <a routerLinkActive="active-item" routerLink="/entrada-periodo" class="vsm-link">
                            <span class="vsm-title">Entrada do Periodo</span></a>
                        </div>


                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>



              </section>

              <section *ngIf="(this.podeAcessar.Dashboard || this.podeAcessar.ConsultarOs 
            || this.podeAcessar.HistoricoEquipamento || this.podeAcessar.QuantitativoServicos) ">
                <ngb-panel>
                  <ng-template ngbPanelHeader>
                    <div class="vsm-header">Módulo Gerencial</div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="dashboard" *ngIf="this.podeAcessar.Dashboard">
                  <ng-template ngbPanelHeader>
                    <a routerLinkActive="active-item" routerLink="/dashboard" ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-display1"></i>
                      <span class="vsm-title" style="text-transform: none;">Dashboard</span>
                    </a>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="dashboard" *ngIf="this.podeAcessar.QuantitativoServicos">
                  <ng-template ngbPanelHeader>
                    <a routerLinkActive="active-item" routerLink="/quantitativo-servico" ngbPanelToggle
                      class="vsm-link">
                      <i class="vsm-icon lnr-chart-bars"></i>
                      <span class="vsm-title" style="text-transform: none;">Quantitativo Serviços</span>
                    </a>
                  </ng-template>
                </ngb-panel>


                <ngb-panel id="consultasgerenciais"
                  *ngIf="(this.podeAcessar.ConsultarOs || this.podeAcessar.HistoricoEquipamento)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-graph2"></i>
                      <span class="vsm-title">Consultas Gerenciais</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.ConsultarOs">
                          <a routerLinkActive="active-item" routerLink="/consultar-os" class="vsm-link">
                            <span class="vsm-title">Consulta OS Emitida</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.HistoricoEquipamento">
                          <a routerLinkActive="active-item" routerLink="/historico-equipamento" class="vsm-link">
                            <span class="vsm-title">Histórico do Equipamento</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.SatisfacaoServico">
                          <a routerLinkActive="active-item" routerLink="/satisfacao-servico" class="vsm-link">
                            <span class="vsm-title">Satisfacao de Serviço</span></a>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>


              </section>


              <section *ngIf="(this.podeAcessar.AreaTecnica ||
              this.podeAcessar.CentroCusto || this.podeAcessar.GrupoLocalNivel ||  this.podeAcessar.Local ||
              this.nivelUsuarioLogado == 5 ||  this.podeAcessar.ClasseEquipamento || this.podeAcessar.Equipamento ||
              this.podeAcessar.Irregularidade || this.podeAcessar.Empreiteira || 
              this.podeAcessar.Prioridade) || (this.podeAcessar.Rotina || this.podeAcessar.Atividade) ||
              (this.podeAcessar.Usuario || this.nivelUsuarioLogado == 5)">
                <ngb-panel>
                  <ng-template ngbPanelHeader>
                    <div class="vsm-header">Módulo Estrutural</div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="cadastrosEstruturais" *ngIf="(this.podeAcessar.AreaTecnica ||
                this.podeAcessar.CentroCusto || this.podeAcessar.GrupoLocalNivel ||  this.podeAcessar.Local ||
                this.nivelUsuarioLogado == 5 ||  this.podeAcessar.ClasseEquipamento || this.podeAcessar.Equipamento ||
                this.podeAcessar.Irregularidade || this.podeAcessar.Empreiteira || 
                this.podeAcessar.Prioridade)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon lnr-apartment"></i>
                      <span class="vsm-title">Cadastros Estruturais</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.AreaTecnica">
                          <a routerLinkActive="active-item" routerLink="/areatecnica" class="vsm-link">
                            <span class="vsm-title">Área Técnica</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.CentroCusto">
                          <a routerLinkActive="active-item" routerLink="/centro-custo" class="vsm-link"> <span
                              class="vsm-title">{{labelCentroCusto}}</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.GrupoLocalNivel">
                          <a routerLinkActive="active-item" routerLink="/grupo-local-nivel" class="vsm-link"> <span
                              class="vsm-title">Grupo local</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.Local">
                          <a routerLinkActive="active-item" routerLink="/local" class="vsm-link">
                            <span class="vsm-title">Local</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.nivelUsuarioLogado == 5">
                          <a routerLinkActive="active-item" routerLink="/tipo-equipamento" class="vsm-link"> <span
                              class="vsm-title">Tipo de Equipamento</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.ClasseEquipamento">
                          <a routerLinkActive="active-item" routerLink="/classe-equipamento" class="vsm-link"> <span
                              class="vsm-title">Classe Equipamento</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.Equipamento">
                          <a routerLinkActive="active-item" routerLink="/equipamento" class="vsm-link">
                            <span class="vsm-title">Equipamento</span></a>
                        </div>

                        <div class="vsm-item" *ngIf="this.podeAcessar.Irregularidade">
                          <a routerLinkActive="active-item" routerLink="/irregularidade" class="vsm-link"> <span
                              class="vsm-title">Código de Irregularidade</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.Empreiteira">
                          <a routerLinkActive="active-item" routerLink="/empreiteira" class="vsm-link"> <span
                              class="vsm-title">Empreiteira</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.Prioridade">
                          <a routerLinkActive="active-item" routerLink="/prioridade" class="vsm-link"> <span
                              class="vsm-title">Prioridade</span></a>
                        </div>

                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="planoBasicoManutencao"
                  *ngIf="(this.podeAcessar.Rotina || this.podeAcessar.Atividade || this.podeAcessar.CalendarioMensal)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-tools"></i>
                      <span class="vsm-title">Calendário de Preventivas</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.Rotina">
                          <a routerLinkActive="active-item" routerLink="/rotina" class="vsm-link"><span
                              class="vsm-title">Rotinas</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.Atividade">
                          <a routerLinkActive="active-item" routerLink="/atividade" class="vsm-link"> <span
                              class="vsm-title">Atividades</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.podeAcessar.CalendarioMensal">
                          <a routerLinkActive="active-item" routerLink="/calendario-mensal" class="vsm-link"> <span
                              class="vsm-title">Calendario Mensal</span></a>
                        </div>

                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>

                <ngb-panel id="acessoAoSistema" *ngIf="(this.podeAcessar.Usuario || this.nivelUsuarioLogado == 5)">
                  <ng-template ngbPanelHeader>
                    <button ngbPanelToggle class="vsm-link">
                      <i class="vsm-icon pe-7s-users"></i>
                      <span class="vsm-title">Acesso ao Sistema</span>
                      <i class="vsm-arrow"></i>
                    </button>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="vsm-dropdown">
                      <div class="vsm-list">
                        <div class="vsm-item" *ngIf="this.podeAcessar.Usuario || this.nivelUsuarioLogado == 5">
                          <a routerLinkActive="active-item" routerLink="/usuario" class="vsm-link"><span
                              class="vsm-title">Usuários</span></a>
                        </div>
                        <div class="vsm-item" *ngIf="this.nivelUsuarioLogado == 5">
                          <a routerLinkActive="active-item" routerLink="/funcionalidades" class="vsm-link"><span
                              class="vsm-title">Funcionalidades</span></a>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </ngb-panel>
              </section>


            </ngb-accordion>

          </div>


        </div>


      </perfect-scrollbar>


    </div>
  </div>





</div>